import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

// CSS para o mapa
import 'leaflet.markercluster'; // Importa o plugin
import 'leaflet.markercluster/dist/MarkerCluster.css'; // CSS dos clusters
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet/dist/leaflet.css';
import "@geoman-io/leaflet-geoman-free";
import "@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css";
import { JSXToHTML } from './core';


window.JSXToHTML = JSXToHTML;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

reportWebVitals();
